import { instance } from "../axios/axiosConfig";

const organizationsApi = {
  fetchOrganizationsList() {
    return instance.get(`/api/organizations/`);
  },
};

export default organizationsApi;
